import {
  PiPower,
  PiWarning,
  PiClock,
  PiClockCountdown,
  PiRadio,
  PiIdentificationCard,
  PiPhone,
  PiCheckCircle,
} from 'react-icons/pi';

export const AVAILABLE_EVENT_EXTRA_FIELDS = [
  'status',
  'severity',
  'activatedTime',
  'deactivatedTime',
  'mmsi',
  'imo',
  'callSign',
  'acknowledged',
] as const;

export type EventExtraField = (typeof AVAILABLE_EVENT_EXTRA_FIELDS)[number];

export const EVENT_FIELD_DISPLAY_NAMES: Record<EventExtraField, string> = {
  status: 'Status',
  severity: 'Severity',
  activatedTime: 'Activated',
  deactivatedTime: 'Deactivated',
  mmsi: 'MMSI',
  imo: 'IMO',
  callSign: 'Call Sign',
  acknowledged: 'Acknowledged',
};

export const getEventFieldDisplayName = (field: string): string => {
  return EVENT_FIELD_DISPLAY_NAMES[field as EventExtraField] || field;
};

export const getEventFieldIcon = (field: string) => {
  switch (field) {
    case 'status':
      return PiPower;
    case 'severity':
      return PiWarning;
    case 'activatedTime':
      return PiClock;
    case 'deactivatedTime':
      return PiClockCountdown;
    case 'mmsi':
      return PiRadio;
    case 'imo':
      return PiIdentificationCard;
    case 'callSign':
      return PiPhone;
    case 'acknowledged':
      return PiCheckCircle;
    default:
      return PiClock;
  }
};
